import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42dbb278&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=42dbb278&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dbb278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42dbb278')) {
      api.createRecord('42dbb278', component.options)
    } else {
      api.reload('42dbb278', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42dbb278&scoped=true&", function () {
      api.rerender('42dbb278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderSystem/components/shopInfo/index.vue"
export default component.exports